import { convertObjectIntoString } from '../../helpers/objectToStringFormat';
import {
  AdminNotificationType,
  AscResponse,
  INotificationList,
  NotificationGroup,
  PaginatedResponse,
  RequestPagination,
} from '../../models';
import { GetNotificationsRequest } from '../../models';
import { httpService } from '../../utilities';
import { NotificationEndpoints } from './notification.endpoints';

export async function getMyNotificationActionsApi(
  notificationsPayload?: GetNotificationsRequest
) {
  return httpService
    .post<PaginatedResponse<NotificationGroup>>(
      NotificationEndpoints.getMyActions,
      notificationsPayload
    )
    .then((res) => res.data);
}

export async function getMyNotificationUpdatesApi(
  notificationsPayload?: GetNotificationsRequest
) {
  return httpService
    .post<PaginatedResponse<NotificationGroup>>(
      NotificationEndpoints.getMyUpdates,
      notificationsPayload
    )
    .then((res) => res.data);
}

export async function getMyNewNotificationsApi(
  params: RequestPagination & { startDate?: string; endDate?: string }
) {
  const { page, pageSize, startDate, endDate } = params;
  const queryParams = {
    ...(page ? { page } : {}),
    ...(pageSize ? { pageSize } : {}),
    ...(startDate ? { startDate } : {}),
    ...(endDate ? { endDate } : {}),
  };
  return httpService
    .get<AscResponse<INotificationList>>(
      `${NotificationEndpoints.getMyNewNotifications}${
        queryParams ? '?' + convertObjectIntoString(queryParams) : ''
      }`
    )
    .then((res) => res.data);
}

export async function getAdminNewNotificationsApi(
  params: RequestPagination & { startDate?: string; endDate?: string }
) {
  const { page, pageSize, startDate, endDate } = params;
  const queryParams = {
    ...(page ? { page } : {}),
    ...(pageSize ? { pageSize } : {}),
    ...(startDate ? { startDate } : {}),
    ...(endDate ? { endDate } : {}),
  };
  return httpService
    .get<AscResponse<INotificationList<AdminNotificationType>>>(
      `${NotificationEndpoints.getAdminNewNotifications}${
        queryParams ? '?' + convertObjectIntoString(queryParams) : ''
      }`
    )
    .then((res) => res.data);
}

export async function markNotificationAsRead(notificationId: string) {
  return httpService
    .patch(NotificationEndpoints.markNotificationAsRead(notificationId))
    .then((res) => res.data);
}

export async function markNotificationStackAsReadApi(notifications: string[]) {
  return httpService
    .patch(NotificationEndpoints.markNotificationStackAsRead, { notifications })
    .then((res) => res.data);
}

export async function markAdminNotificationAsRead(notificationId: string) {
  return httpService
    .patch(NotificationEndpoints.markAdminNotificationAsRead(notificationId))
    .then((res) => res.data);
}

export async function markAdminNotificationStackAsReadApi(
  notifications: string[]
) {
  return httpService
    .patch(NotificationEndpoints.markAdminNotificationStackAsRead, {
      notifications,
    })
    .then((res) => res.data);
}
